import { GameProps, gamePropsNull } from './game.props'
import { Contract } from './contract'
import { Game } from './game'
import { Card } from './card'

interface ContractDeclarationGameProps extends GameProps {
  readonly userContractOptions: Contract[]
}

export class ContractDeclarationGame extends Game {
  public readonly userContractOptions =
    this.contractDeclarationGameProps.userContractOptions

  public constructor(
    private readonly contractDeclarationGameProps: ContractDeclarationGameProps,
  ) {
    super(contractDeclarationGameProps)
  }

  public selectTalonCard(talonCard: Card): void {
    this.user.addCard(talonCard)
    this.talonCards = this.talonCards.filter((card) => card !== talonCard)
  }

  public selectUserCard(userCard: Card): void {
    this.user.removeCard(userCard)
    this.talonCards = this.talonCards.filter((card) => card)
    this.talonCards.push(userCard)
  }

  public override getIsUserCardsSelectable(): boolean {
    return this.talonCards.length < 2
  }

  public getIsOptionsDisabled(): boolean {
    return this.talonCards.length != 2
  }
}

export const contractDeclarationGameNull: ContractDeclarationGame =
  new ContractDeclarationGame({
    ...gamePropsNull,
    userContractOptions: [],
  })
